import React from 'react';

export function SelectionCategory (props) {
  console.log(props)
  return (
    <option onChange={props.onChange}>{props.type === 'except' ? props.item.title : props.item.nameRu}</option>
  )
}

